import React from "react";
import Update from "modules/countries/components/Update";

const CountriesUpdatePage = () => {
  return <Update />;
};

export default CountriesUpdatePage;
